import React from "react";
import { Row } from "react-bootstrap";
import Scrollbars from "react-custom-scrollbars-2";
import { IOfferItem } from "../../../models/cart.model";
import styleClasses from "../../Header/Header.module.scss";
import OfferItemCard from "./OfferItemCard";
import { useLocation } from "react-router-dom";
import useCheckMobileScreen from "../../../hooks/useCheckMobileScreen";
import { useIsDesignV2 } from "../../../hooks/useIsDesignV2";

interface IOfferItemListProps {
  offers: IOfferItem[];
  selectedOfferItem: IOfferItem;
  isRewardList: boolean;
  closeModal: () => void;
  title: string;
  addToOrder: () => void;
  rewardsDiscountedSubTotal: number;
  isDisabled?: boolean;
}

const OfferItemsList: React.FC<IOfferItemListProps> = (props) => {
  const location = useLocation();
  const isItMobile = useCheckMobileScreen();
  const isDesignV2 = useIsDesignV2();
  const { offers, selectedOfferItem, closeModal, title, addToOrder, rewardsDiscountedSubTotal, isDisabled } =
    props;
  const getBtnText = (reward) => {
    return reward.in_cart ? "Redeemed" : "Redeem";
  };
  if (!offers?.length) return null;

  return (
    <>
      <div className={`${styleClasses.other_products_wrap} ${isDesignV2 ? styleClasses.redeemm_reward_wrap_mobile_designv2  : ''}`}>
        <h4 className={` font-Cls lh-normal ls-normal mb-3 ${isDesignV2 ? 'f-sm-s21 f-w4 clr-dark-grey' : 'f-s22 f-sm-s16'}`}>
          {title}
        </h4>
        <Row className={styleClasses.suggestion_row + " flex-nowrap pt-1 "}>
          <Scrollbars
            className={`${styleClasses.offers_scrolbar_height} ${isDesignV2 ? styleClasses.other_products_Scrollbar : ''}`}
            renderThumbHorizontal={(props) => (
              <div {...props} className={styleClasses.Scrollbar_thumb} />
            )}
            renderView={(props) => (
              <div {...props} className={styleClasses.Scrollbar_view} />
            )}
          >


            {offers.map((offerItem: IOfferItem, index: number) => {
              return (
                <OfferItemCard
                  key={index}
                  handleRedeemClick={() => { }}
                  offerItem={offerItem}
                  selectedOfferItem={selectedOfferItem}
                  rewardsDiscountedSubTotal={rewardsDiscountedSubTotal}
                  btnText={getBtnText(offerItem)}
                  isDisabled={isDisabled}
                />
              );
            })}
          </Scrollbars>
        </Row>
      </div>
      <hr className="shadow-divider mb-4 border-0" />
    </>

  );
};

export default OfferItemsList;
